
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.628 12.203a1 1 0 011.192.76l4.35 19.622h15.136a1 1 0 110 2h-2.093l2.471 11.862a1 1 0 11-1.958.407l-2.556-12.27h-7.048l-2.574 12.272a1 1 0 11-1.957-.41l2.488-11.861h-2.71a1 1 0 01-.977-.784L5.868 13.396a1 1 0 01.76-1.193zM27.282 22.716a1 1 0 011-1H54a1 1 0 110 2H42.14V46.65a1 1 0 01-2 0V23.716H28.283a1 1 0 01-1-1z"}})])
          )
        }
      }
    